import { Address } from './address';
import { ClientDetails } from '../client/client-details';
import { ProviderDetails } from '../provider/provider-details';

export interface Business {
  addresses?: Address[];
  aliases?: string[];
  businessTypes: number[];
  code: string;
  createdBy?: string;
  createdDate?: string;
  id: string;
  leadAssociateUserName?: string;
  lotNumbers?: string[];
  modifiedBy?: string;
  modifiedDate?: string;
  name: string;
  taxIndicatorCode?: string;
  clientDetails?: ClientDetails; // Carries paymentTermsCode for client/customer businesses
  providerDetails?: ProviderDetails; // Carries paymentTermsCode for provider/vendor businesses
  fieldToDisplay?: string; // Optional field for displaying in typeahead
}

export enum BusinessEntityType {
  Provider,
  Client,
  Manufacturer,
  Consignee,
  Brand,
  InternalCompany,
}
